import { useStoreActions } from 'Store'
import { Buffer } from 'buffer';

interface UseInitializeAppReturn {
  initializeApp: () => void;
}

export const useAppInitializer = (): UseInitializeAppReturn => {
  const { setHasAccess, setIsLoading } = useStoreActions(action => action.LoaderModel)
  const { setUser } = useStoreActions(action => action.UserModel)

  const urlParams = new URLSearchParams(window.location.search)
  let token = urlParams.get('q')
  if (token !== null && token.length > 0) {
    localStorage.setItem('_auth', token)
  } else {
    token = localStorage.getItem('_auth')
  }
  const checkUserExists = (userId: string): boolean => {
    if (userId !== null) {
      return true
    } else return false
  }
  const roleString = (roles: unknown): string => {
    if (Array.isArray(roles)) {
      return roles.join(',')
    }
    if (typeof roles === 'string') {
      return roles
    }
    return ''
  }
  // Staff for this tool: account/course/department admin or teacher
  const checkAuthsAdmin = (membershipRoles: string): boolean => {
    if (membershipRoles !== null && membershipRoles !== undefined && membershipRoles !== '') {
      if (membershipRoles.match(/account admin/i) != null) {
        return true
      } else if (membershipRoles.match(/\bteacher/i) != null) {
        return true
      } else if (membershipRoles.match(/course admin/i) != null) {
        return true
      } else if (membershipRoles.match(/department admin/i) != null) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }
  const decode = (str: string): string => Buffer.from(str, 'base64').toString('binary')

  const initializeApp = async (): Promise<void> => {
    if (token === null) {
      setIsLoading(false)
      setHasAccess(false)
    } else {

      var decoded = null
      try {
        decoded = JSON.parse(JSON.parse(decode(token)))
      } catch (error) { 
        console.error('Error decoding token')
        setIsLoading(false)
        setHasAccess(false)
        return
      }

      const userId = decoded.userId ?? decoded.user_id
      const membershipRoles = roleString(decoded.membershipRoles ?? decoded.membership_roles)
      if (checkUserExists(userId)) {
        const staff = checkAuthsAdmin(membershipRoles)
        setUser({
          ...decoded,
          staff
        })
        setIsLoading(false)
        setHasAccess(staff)
      } else {
        setIsLoading(false)
        setHasAccess(false)
      }
    }
  }

  return { initializeApp };
};
